import { ThreeDots } from "react-loader-spinner";

export const ComponentLoader = () => {
    return <ThreeDots color="#001E6C" height={40} width={40} />
}